import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { SUPPORTED_LANGS } from "../i18n";

/**
 * variant:
 *   "sidebar" — dark background (for the dark navy sidebar)
 *   "light"   — light background (for login page)
 */
export const LanguageSwitcher = ({ variant = "light", className = "" }) => {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || "en";

  const onChange = (e) => {
    const next = e.target.value;
    i18n.changeLanguage(next);
    try { localStorage.setItem("gd_lang", next); } catch { /* no-op */ }
  };

  const base = "inline-flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium transition-colors";
  const styles = variant === "sidebar"
    ? "bg-white/5 text-slate-200 hover:bg-white/10 border border-white/10"
    : "bg-white text-slate-700 hover:bg-slate-50 border border-slate-200";

  return (
    <div className={`${base} ${styles} ${className}`} data-testid="language-switcher">
      <Globe size={16} className={variant === "sidebar" ? "text-slate-300" : "text-slate-500"} />
      <select
        aria-label="Language"
        value={current}
        onChange={onChange}
        data-testid="language-select"
        className={`cursor-pointer bg-transparent text-sm font-medium outline-none ${
          variant === "sidebar" ? "text-slate-100" : "text-slate-700"
        }`}
      >
        {SUPPORTED_LANGS.map((l) => (
          <option
            key={l.code}
            value={l.code}
            className="bg-white text-slate-800"
            data-testid={`language-option-${l.code}`}
          >
            {l.native}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
